export default __webpack_public_path__ + "static/media/c6.f2f16bb9.png";